import { logEvent } from "firebase/analytics";
import { analytics } from "../App";

export const EVENT_NAMES_CONSTANT = {
  search_button_clicked: "search_button_clicked",
  failed_to_load: "failed_to_load",
  get_otp_clicked: "get_otp_clicked",
  logout_clicked: "logout_clicked",
  card_header_click: "card_header_click",
  status_clicked: "status_clicked",
  timeline_clicked: "timeline_clicked",
  troubleshoot_clicked: "troubleshoot_clicked",
  resource_okay_clicked: "resource_okay_clicked",
  tps_okay_clicked: "tps_okay_clicked",
  app_okay_clicked: "app_okay_clicked",
  nas_resources_clicked: "nas_resources_clicked",
  qr_clicked: "qr_clicked",
  tv_enrolment_clicked: "tv_enrolment_clicked",
  enrolment_submitted: "enrolment_submitted",
  enrolment_status_changed: "enrolment_status_changed",
  login_clicked: "login_clicked",
  login_failed: "login_failed",
  login_success: "login_success",
  troubleshoot_triggered: "troubleshoot_triggered",
  one_click_triggered: "one_click_triggered",
  system_okay_clicked: "system_okay_clicked",
  sdcard_okay_clicked: "sdcard_okay_clicked",
};

export const logFirebaseEvent = (eventName, properties) => {
  logEvent(analytics, eventName, properties);
};
